export enum ApiRoutesNotifications {
  Notifications = "admin/custom-notifications"
}

export {
  NotificationRepetitionType,
  NOTIFICATION_REPETITION_LIST
} from "./repetitionType";
